import React, { useEffect } from "react";
import { Loading } from "components";
import { useDeveloperStore } from "./stores/developerStore";

import TokensPanel from "./components/TokensPanel";
import ApiDocs from "./components/ApiDocs";

// Головний компонент сторінки "Розробник": API-токени та документація read-only API
const DeveloperPage = () => {
  const isLoading = useDeveloperStore((state) => state.isLoading);
  const init = useDeveloperStore((state) => state.init);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <section id="developer-page">
      <div className="page-container">
        <div className="developer-title">
          <h3>Документація API</h3>
          <p className="muted">
            Доступ до даних ЦАУ для зовнішніх інтеграцій: створіть токен і передайте його
            разом із документацією своєму скрипту або агенту.
          </p>
        </div>

        {isLoading ? (
          <Loading />
        ) : (
          <>
            <TokensPanel />
            <ApiDocs />
          </>
        )}
      </div>
    </section>
  );
};

export default DeveloperPage;
